import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
function CustomerFeedback({ viewMoreValue }) {
  const seckey =
    "enyugewhb.f736723dg32bjadf3fgdawgef3w37ff.gwsbghasefgy3fgs8d3w237dghg2dywgawydatwefgda823dgwdt3g4wgeagdsudhir";

  const [reviwStar, setReviwStar] = useState("");

  const [loading, setloading] = useState(false);

  const [page, setPage] = useState(1);

  const [reviewsDataList, setReviewDataList] = useState();

  const [activeViewMore, setActiveViewMore] = useState("");

  const [expandedIndexes, setExpandedIndexes] = useState({});


  const getReviewsStar = async () => {
    setloading(true);
    try {
      const response = await fetch(
        `https://server.review.glazma.com/auth/v4/get-ratting-star`,
        {
          method: "GET",
          headers: {
            Content: "application/json",
            seckey: seckey,
          },
        },
      );
      const data = await response.json();
      if (response.ok) {
        setReviwStar(data);
      }
    } catch (error) {
      console.log(error);
    }
    setloading(false);
  };

  const getCustomerFeedbackList = async (page) => {
    setloading(true);
    try {
      const response = await fetch(
        `https://server.review.glazma.com/auth/v4/get-ratting?page=${page}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            seckey: seckey,
          },
        },
      );
      const data = await response.json();
      if (response.ok) {
        setReviewDataList(data);
      } else {
      }
    } catch (error) {
      console.log(error);
    }
    setloading(false);
  };

  const getMoreList = () => {
    if (reviewsDataList && page < reviewsDataList.totalPages) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    getReviewsStar();
    getCustomerFeedbackList(page);

    setActiveViewMore(viewMoreValue);
  }, [page]);




const toggleReadMore = (index) => {
  setExpandedIndexes((prev) => ({
    ...prev,
    [index]: !prev[index],
  }));
};


  return (
    <div>
      <div className="customer-reviews-bg">
        <div className="customer-reviews-main">
          <div className="customer-reviews-main-headline  why-us-heading  ">
            CUSTOMERS SPEAKS{" "}
          </div>

          <div className="customer-reviews-main-row">
            <div className="customer-reviews-cols-data">
              <p className="average-rating">
                {" "}
                <i class="fa-solid fa-star"></i>4.9{" "}
              </p>

              <div className="reviews-bars-progress-cont">
                <ul>
                  {reviwStar && reviwStar.distribution && reviwStar.total ? (
                    Object.entries(reviwStar.distribution)
                      .sort((a, b) => b[0] - a[0])
                      .map(([rating, count]) => {
                        const totalReviews = Number(reviwStar.total);
                        const starCount = Number(count);
                        const percentage = (starCount / totalReviews) * 100;

                        return (
                          <li
                            className="rev-progress-outer-div-cont"
                            key={rating}
                          >
                            <div className="rev-progress-label">
                              <span>
                                <i className="fa-solid fa-star"></i> {rating}
                              </span>
                            </div>

                            <div className="rev-progress-bar">
                              <div
                                className="rev-progress-bar-fill"
                                style={{ width: `${percentage}%` }}
                              ></div>
                            </div>

                            <p className="rev-star-count-value-cont">
                              {starCount}
                            </p>
                          </li>
                        );
                      })
                  ) : (
                    <li>No data available.</li>
                  )}
                </ul>
              </div>

              <div className="cs-rev-scanner-qr-container">
                <div>
                  {/* <img src='https://res.cloudinary.com/db7huekcf/image/upload/v1764069940/glazma-feedback_n77iiu.jpg'></img> */}
                </div>

                <div>
                  <Link to="https://customer.rating.management.bhumu.com/glazma-your-feedback">
                    Write customer Reviews{" "}
                  </Link>{" "}
                </div>
              </div>
            </div>


          <div className='customer-rev-star-data-list-row'>

  {reviewsDataList?.data &&
    reviewsDataList.data?.map((e, i) => {
      const isLong = e.ratingMessage.length > 220;
      const isExpanded = expandedIndexes[i];

      return (
        <div className="customer-rev-star-data-list-cols" key={i}>
          <p className='happy-cs-profile-name'>
            <div>
              {e.customerName}{" "}
              {e.servicesName && (
                <span>
                  ({e.servicesName.split(' ').slice(0, 4).join(' ')}
                  {e.servicesName.split(' ').length > 4 ? '...' : ''})
                </span>
              )}
            </div>

            {e.ratingNumber && (
              <div>
                <i className="fa-solid fa-star"></i> {e.ratingNumber}
              </div>
            )}
          </p>

          <p className='happy-cs-reviews-details'>
            {isExpanded || !isLong
              ? e.ratingMessage
              : e.ratingMessage.slice(0, 200) + "..."}

            {isLong && (
              <span
                className="read-more-less-btn"
                onClick={() => toggleReadMore(i)}
                style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px', fontWeight: 500 }}
              >
                {isExpanded ? " Read Less" : " Read More"}
              </span>
            )}
          </p>
        </div>
      );
    })}

</div>


          </div>

           {loading ? (
                <div className="show-more-btn-of-customer-rev">Loading...</div>
              ) : (
                <div
                  className="show-more-btn-of-customer-rev"
                  onClick={() => getMoreList()}
                >
                  Show More
                </div>
              )}



          {/* {activeViewMore === "active" ? (
            <>
              {loading ? (
                <div className="show-more-btn-of-customer-rev">Loading...</div>
              ) : (
                <div
                  className="show-more-btn-of-customer-rev"
                  onClick={() => getMoreList()}
                >
                  Show More
                </div>
              )}
            </>
          ) : (
            ""
          )} */}


        </div>
      </div>
    </div>
  );
}

export default CustomerFeedback;

// export default CustomerFeedback
